const doc = [({"en":({"js":({"shared":({"no":"No", "yes":"Yes"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;